<template>
	<div class="tusd-wrap wrap-bg header-scroll">
		<div class="page-title">
			<i class="back-btn" @click="goBack"></i>
			修改密码
		</div>
		<div class="separator"></div>
		<div class="account-wrap reset-info">
			<div class="wrap-item">
				<span class="item-label reset-label">旧密码：</span>
				<input type="password" v-model="reset.oldPassword" placeholder="请输入您的旧密码" />
			</div>
			<div class="wrap-item">
				<span class="item-label reset-label">新密码：</span>
				<input type="password" v-model="reset.password" placeholder="请输入您的新密码" />
			</div>
			<div class="wrap-item">
				<span class="item-label reset-label">确认密码：</span>
				<input type="password" v-model="reset.rePassword" placeholder="请确认您的新密码" />
			</div>
			<div class="tusd-btn" @click="goResetPwd">确认修改</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'reset',
	data() {
		return {
			reset: {
				oldPassword: '',
				password: '',
				rePassword: '',
				accoutType:_ACCOUNTTYPY_
			},
			params: {},
		};
	},
	methods: {
		goBack() {
			this.$router.push({ name: this.params.back });
		},
		goResetPwd() {
			let that=this;
			if(!that.reset.oldPassword){
				 that.$message.popup("请输入原密码",1000);
	  			return false
	  		}
			if(!that.reset.password){
				 that.$message.popup("请输入新密码",1000);
	  			return false
	  		}
			if(!that.verify.verifyPassword(that.reset.password)){
				 that.$message.popup("请输入6~20位数字、字母或字符",1000);
	  			return false
	  		}
			if(that.reset.password != that.reset.rePassword){
				 that.$message.popup("两次密码不一致",1000);
	  			return false
	  		}
			that.$api.changePassword(that.reset).then(res => {
				that.$message.popup("修改密码成功",1000);
				that.$router.push({ name: 'login' })
			});
		}
	},
	created() {
		this.params = this.$store.state.routerStore.reset;
	}
};
</script>

<style lang="less" scoped>
.reset-info {
	padding: 26px;
	.tusd-btn {
		margin-top: 60px;
	}
}
</style>
